import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { FeatureFlag } from 'src/auth/feature-flags';
import FeatureFlagGuard from 'src/auth/guard/feature-flag-guard';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/domains/dashboard/index'));
const SettingsPage = lazy(() => import('src/domains/dashboard/settings'));
const CompanyUsersPage = lazy(
  () => import('@src/domains/business/user-management/pages/UserManagementPage')
);
const CompanyRolesPage = lazy(
  () => import('@src/domains/business/role-management/pages/RoleManagementPage')
);
const CustomFieldsManagementPage = lazy(
  () => import('@src/domains/business/custom-fields/pages/CustomFieldsManagementPage')
);
// ----------------------------------------------------------------------
export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'settings', element: <SettingsPage /> },
      {
        path: 'settings/custom-fields',
        element: (
          <FeatureFlagGuard flag={FeatureFlag.CustomFields}>
            <CustomFieldsManagementPage />
          </FeatureFlagGuard>
        ),
      },
      { path: 'users', element: <CompanyUsersPage /> },
      { path: 'roles', element: <CompanyRolesPage /> },
    ],
  },
];
